// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ca6b1f85","header":"_20bc67a9","message":"_a9298d5d"};